export const BUSINESS_ACCOUNTS_PATH = '/business/accounts'
export const BUSINESS_APPLY_PATH = '/business/apply'
export const BUSINESS_APPLY_PAGE_NAME = 'business/apply'

export function isBusinessAppPath(pathname: string): boolean {
  return pathname === '/business' || pathname.startsWith('/business/')
}

export function isBusinessAccountsPath(pathname: string): boolean {
  return pathname === BUSINESS_ACCOUNTS_PATH || pathname.startsWith(`${BUSINESS_ACCOUNTS_PATH}/`)
}

export function isBusinessApplyPath(pathname: string): boolean {
  return pathname === BUSINESS_APPLY_PATH || pathname.startsWith(`${BUSINESS_APPLY_PATH}/`)
}

export function isApplyFlowPath(pathname: string): boolean {
  return pathname === '/apply' || pathname.startsWith('/apply/') || isBusinessApplyPath(pathname)
}

export function buildBusinessApplyResumePath(applicationId: string): string {
  return `${BUSINESS_APPLY_PATH}?resume=${encodeURIComponent(applicationId)}`
}
